export const FINANCEIRO_TIPO_MOVIMENTO_ENUM = [
    {
        id: 'ENTRADA',
        descricao: "ENTRADA",
    },
    {
        id: 'SAIDA',
        descricao: "SAÍDA",
    },
];